<div class="dialog">
  <div class="message">{{data.message}}</div>
  <div class="actions-wrapper">
    <div class="dialog-actions">
      <button
        mat-stroked-button
        (click)="this.onOkClick()">Ok</button>
    </div>
  </div>
</div>